export default "__VITE_ASSET__OiJj2Ae$__"